
const getWhitelistedAssets = () => process.env.VUE_APP_WHITELISTED_ASSETS.split(',')

export default {
  getWhitelistedAssets
}